<script setup>
import { ref, onMounted, watch } from "vue";
import { useRoute } from "vue-router";
import SidebarCourses from "./SidebarCourses.vue";
import SidebarDevices from "./SidebarDevices.vue";
import SidebarUtilities from "./SidebarUtilities.vue";
import SidebarUsers from "./SidebarUsers.vue";

const route = useRoute();

const activeMenu = ref(localStorage.getItem("activeMenu") || "courses");
const activeItem = ref(localStorage.getItem("activeItem") || "all-courses");

const setActiveMenu = (item) => {
  activeMenu.value = item;
  localStorage.setItem("activeMenu", item);
};

const setActiveItem = (item) => {
  activeItem.value = item;
  localStorage.setItem("activeItem", item);
};

onMounted(() => {
  activeMenu.value = localStorage.getItem("activeMenu") || "courses";
  activeItem.value = localStorage.getItem("activeItem") || "all-courses";
});

watch(
  route,
  (newRoute) => {
    if (newRoute.meta.title === "utilities") {
      activeMenu.value = newRoute.meta.title;
      activeItem.value = newRoute.meta.title;
    } else {
      setActiveItem(newRoute.meta.title);
      setActiveMenu(newRoute.meta.menu);
    }
  },
  { immediate: true }
);

watch(activeMenu, (newVal) => {
  localStorage.setItem("activeMenu", newVal);
});

watch(activeItem, (newVal) => {
  localStorage.setItem("activeItem", newVal);
});
</script>

<template>
  <div class="sidebar">
    <nav class="mt-2">
      <ul
        class="nav nav-pills nav-sidebar flex-column"
        data-widget="treeview"
        role="menu"
        data-accordion="false"
      >
        <SidebarCourses
          :activeMenu="activeMenu"
          :activeItem="activeItem"
          @setActiveMenu="setActiveMenu"
          @setActiveItem="setActiveItem"
        />
        <SidebarDevices
          :activeMenu="activeMenu"
          :activeItem="activeItem"
          @setActiveMenu="setActiveMenu"
          @setActiveItem="setActiveItem"
        />
        <SidebarUtilities
          :activeMenu="activeMenu"
          @setActiveMenu="setActiveMenu"
        />
        <SidebarUsers
          :activeMenu="activeMenu"
          :activeItem="activeItem"
          @setActiveMenu="setActiveMenu"
          @setActiveItem="setActiveItem"
        />
      </ul>
    </nav>
  </div>
</template>
